import { Colour, Tag } from '@ukpostbox/frontend-framework';
import React from 'react';

export interface FilterItemType {
	content: any;
	colour?: Colour;
	callback?: any;
}

function FilterItem(props: FilterItemType) {
	return (
		<Tag
			id={props.content}
			name={props.content}
			removeCallback={() => props.callback()}
			hideIcon
			colour={props.colour ? props.colour : Colour.Primary}
		/>
	);
}

export default FilterItem;
